export const calculateValuePerUnit = ({
  total,
  quantity,
}: {
  total?: number;
  quantity?: number;
}) => {
  // total can be 0, but quantity cannot, hence the difference in truthiness check
  if (total === undefined || !quantity) {
    return;
  }

  return total / quantity;
};
